var localStorage = window?.localStorage;
if(!localStorage) {
    console.error('local storage is not supported.');
    localStorage = {
        setItem(k, v) { this[k] = v; },
        getItem(k) { return this[k] ?? null; }
    };
}

export default localStorage;